"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useWallet } from "@/contexts/wallet-context"
import { ChevronDown } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { useRouter } from "next/navigation"

function truncate(addr?: string | null) {
  if (!addr) return ""
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`
}

interface HeaderConnectProps {
  size?: "default" | "large"
}

export function HeaderConnect({ size = "default" }: HeaderConnectProps) {
  const { address, connectMetaMask, connectWalletConnect, disconnect, connecting } = useWallet()
  const [open, setOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const router = useRouter()

  const buttonSize = size === "large" ? "lg" : "default"
  const buttonClass = size === "large" ? "text-lg" : ""

  if (!address) {
    return (
      <div data-no-toggle="true" onClick={(e) => e.stopPropagation()}>
        <button 
          className={`text-gray-950 text-md uppercase font-funnel font-medium hover:text-brand-purple transition-colors flex items-center h-full ${buttonClass}`}
          onClick={() => setOpen(true)} 
          disabled={connecting}
        >
          Connect
        </button>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="sm:max-w-md w-full max-w-[calc(100vw-2rem)] rounded-2xl mx-auto">
            <DialogHeader>
              <DialogTitle className="text-lg font-medium font-funnel">Connect Wallet</DialogTitle>
            </DialogHeader>
            <div className="grid grid-cols-1 gap-3">
              <Button onClick={() => { setOpen(false); connectMetaMask(); }}>
                <span className="font-funnel text-sm font-medium uppercase">MetaMask</span>
              </Button>
              <Button className="bg-black hover:bg-gray-900 text-white" onClick={() => { setOpen(false); connectWalletConnect(); }}>
                <span className="font-funnel text-sm font-medium uppercase">WalletConnect</span>
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    )
  }

  return (
    <div data-no-toggle="true" onClick={(e) => e.stopPropagation()}>
      <Popover open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverTrigger asChild>
          <button 
            className={`text-gray-950 text-md uppercase font-funnel font-medium hover:text-brand-purple transition-colors flex items-center h-full gap-2 ${buttonClass}`}
          >
            {truncate(address)}
            <ChevronDown className="h-4 w-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-44 p-2 rounded-2xl">
          <div className="flex flex-col">
            <Button
              variant="ghost"
              className="justify-start"
              onClick={() => {
                setMenuOpen(false)
                router.push(address ? `/results?wallet=${address}` : "/results")
              }}
            >
              <span className="font-funnel font-medium uppercase">My Totem</span>
            </Button>
            <Button variant="ghost" className="justify-start" onClick={() => { setMenuOpen(false); disconnect(); }}>
              <span className="font-funnel font-medium uppercase">Disconnect</span>
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
